import { styled } from 'styled-components';
import { SkeletonLoaderMixin } from '../../../constants/mixin.mjs';
"use strict";
const CircleLoaderContainer = styled.div`
  height: ${({
  $diameter
}) => $diameter}px;
  width: ${({
  $diameter
}) => $diameter}px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`;
const SkeletonLoaderAnimation = styled.div`
  ${SkeletonLoaderMixin}
`;
export { CircleLoaderContainer, SkeletonLoaderAnimation };
//# sourceMappingURL=SkeletonCircleLoader.styles.mjs.map
